import { extend } from 'vee-validate';

import { PaymentCardValidator } from '../utilities';

extend('card_number', PaymentCardValidator.validateNumber);
